export const parseThankviewLink = (htmlBody, parsedBody) => {
  // Extract ThankView video link if present
  const thankviewRegex = /(https?:\/\/(?:www\.)?thankview\.com\/video[^\s"'<>]+)/i;
  const match = htmlBody.match(thankviewRegex);

  if (match) {
    const thankviewLink = match[1];

    // parsedBody is HTML (<br> line breaks), which doesn't accumulate stray whitespace
    // the way raw \n runs did, so no trimming/collapsing pass is needed here.
    parsedBody += `<br><br>ThankView video link: ${thankviewLink}`;
  }

  return parsedBody;
};
